import { css } from "styled-components";
import { isPositionBottom, isPositionLeft, isPositionRight, isPositionTop } from "./isPosition";
import { TOOLTIP_ARROW_SIZE } from "../consts";

var resolveTooltipArrowPosition = function resolveTooltipArrowPosition(_ref) {
  var position = _ref.position;
  var cssPosition = isPositionTop(position) && "bottom" || isPositionBottom(position) && "top" || isPositionLeft(position) && "right" || isPositionRight(position) && "left";
  return css(["", ":-", "px;"], cssPosition, parseFloat(TOOLTIP_ARROW_SIZE));
};

export default resolveTooltipArrowPosition;